import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { shoppersAdminRouter } from './routing/shoppersAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { ShoppersAdminViewAccessControl } from './access-control/shoppersAdminAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'shoppers-admin',
  totem: {
    tool: 'shoppers-admin-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {},
  routers: {
    admin: [shoppersAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachToV3: AdminNavEntryPointV3.ShoppersAdmin,
      subNavItems: [
        {
          // Landing = legacy `admin/shoppers` search/index page. The wildcard
          // below is what actually renders every drill-down (`/care/shoppers/:id`,
          // `/shoppers/:id/notes`, etc.); listing it under `subRoutes` keeps this
          // L1 highlighted while the user is anywhere in the shoppers-admin tree.
          route: 'app-admin-shoppers-admin-shoppers-index',
          labelId: 'shoppersAdminDomain.admin.shoppersAdmin.title',
          subRoutes: ['app-admin-shoppers-admin-dashboard-wildcard'],
          accessControl: ShoppersAdminViewAccessControl,
        },
      ],
    },
  ],
  // NOTE TO DEV: run `pnpm ipp domain register shoppers-admin` to register your domain with Totem here
}

export default definition
